import * as React from "react";
import { View, StyleSheet, Linking, Platform } from "react-native";
import Svg, { Path } from "react-native-svg";
import { Text, theme, typography } from "ui-components";
import { Grid, Container, Row, Column } from "ui-grid";
import { domusoResponsiveStyleHelper } from "../../../screens/new/utils/domuso-responsive";

export const Footer = () => {
  const legalUrl = "https://www.domuso.com/legal/";
  const privacyUrl = "https://www.domuso.com/privacy/";
  const styles = getStyles();
  return Platform.OS == "web" ? (
    <>
      <View style={{ flex: 1 }} />
      <View style={styles.container}>
        <Grid>
          <Container style={{ width: "100%", alignItems: "center" }}>
            <Row>
              <Column>
                <View style={styles.imageContainer}>
                  <Svg
                    width={36}
                    height={48}
                    viewBox="0 0 36 48"
                    fill="none"
                    xmlns="http://www.w3.org/2000/svg">
                    <Path
                      fillRule="evenodd"
                      clipRule="evenodd"
                      d="M31.458 2.068v1.894h3.988V.174h-3.988v1.894zm-6.537 1.645l.057 1.944h3.988l.057-1.944.057-1.944h-4.216l.057 1.944zm4.543 5.433v2.393h4.785V6.754h-4.785v2.392zm-5.333-1.25l-3.04.064v13.704l-1.354-.551C8.909 16.706-2.388 27.147 1.233 38.215c4.205 12.853 22.342 12.813 26.51-.06.657-2.027.736-3.96.597-14.604l-.136-10.417H26.673V9.545h1.618l-.061-.847c-.072-.984.37-.897-4.1-.802zm6.53 6.634v1.196h2.591v-2.393H30.66v1.197zM17.378 27.968c3.633 1.777 4.889 7.063 2.361 9.939-.512.582-.736.43-2.728-1.845-2.646-3.022-2.547-3.03-5.475.459-1.944 2.316-2.67 2.145-3.536-.83-1.559-5.365 4.314-10.201 9.378-7.723z"
                      fill="#F26924"
                    />
                  </Svg>
                </View>
              </Column>
            </Row>

            <View style={{ marginVertical: 5 }} />
            <Row>
              <Column>
                <View>
                  <Text style={styles.title}>Domuso Inc.</Text>
                </View>
              </Column>
            </Row>

            <View style={{ marginVertical: 5 }} />
            <View
              style={{
                flex: 1,
                flexDirection: "row",
              }}>
              <Row>
                <Column>
                  <View style={styles.linksContainer}>
                    <Text style={styles.links} onPress={() => Linking.openURL(legalUrl)}>
                      Legal
                    </Text>
                  </View>
                </Column>
              </Row>
              <Row>
                <Column>
                  <View style={styles.linksContainer}>
                    <Text style={styles.links} onPress={() => Linking.openURL(privacyUrl)}>
                      Privacy
                    </Text>
                  </View>
                </Column>
              </Row>
            </View>
            <View style={{ marginVertical: 8 }} />
          </Container>
        </Grid>

        <View style={{ width: "100%", borderWidth: 0.5, borderBottomColor: theme.colors.stroke }} />
        <Grid>
          <Container style={{ width: "100%", alignItems: "center" }}>
            <View style={{ marginVertical: 8 }} />

            <View
              style={{
                flex: 1,
                flexDirection: "row",
              }}>
              <View style={styles.copyrightContainer}>
                <Text style={styles.copyright}>Copyright</Text>
              </View>
              <View style={styles.copyrightContainer}>
                <Text style={styles.copyright}>©</Text>
              </View>
              <View style={styles.copyrightContainer}>
                <Text style={styles.copyright}>{new Date().getFullYear()} Domuso, Inc.</Text>
              </View>
            </View>
          </Container>
        </Grid>
      </View>
    </>
  ) : null;
};

const getStyles = () => {
  return StyleSheet.create({
    container: {
      width: "100%",
      alignSelf: "flex-end",
      bottom: 0,
      padding: "5%",
      paddingVertical: 15,
      backgroundColor: theme.colors.secondary,
      ...domusoResponsiveStyleHelper({
        webPhone: { marginTop: 50 },
        webTablet: { marginTop: 220 },
        webDesktop: { marginTop: 150 },
        iosPhone: { marginTop: 35 },
        iosTablet: { marginTop: 100 },
        androidPhone: { marginTop: 35 },
        androidTablet: { marginTop: 300 },
      }),
    },
    imageContainer: {
      width: 26.18,
      height: 35.74,
    },
    title: {
      ...typography.title2,
      fontWeight: "500",
      color: theme.colors.lightGrey,
    },
    links: {
      ...typography.subHeading,
      fontFamily: "Lato_700Bold",
      color: theme.colors.lightGrey,
      textAlign: "center",
    },
    linksContainer: {
      paddingHorizontal: 14,
    },
    copyrightContainer: {
      paddingHorizontal: 5,
    },
    copyright: {
      ...typography.subHeading,
      fontWeight: "500",
      color: "#D1D1D1",
      textAlign: "center",
    },
  });
};
